import React from 'react';
import { useNavigate } from 'react-router';
import { equipmentTypeSchema } from '../../../../common/src/domain/drone/equipment/equipmentSchemas';
import { useTranslate } from '../../mixins/translate/translate';
import {
    Content,
    EditPanel,
    EditPanelButtons,
    EditPanelCell,
    EditPanelRow,
    Panel,
    PanelBody,
    PanelButton,
    Topbar,
    TopbarCrumbActive,
    TopbarLeft,
    Tray,
} from '../elements';
import { ValidatingEditPanelSaveButton, ValidatingEditPanelSwitch, ValidatingForm, ValidatingFormInputText } from '../validatingElements';

export function EquipmentTypesAddEdit(props: { params: { id?: string } }) {
    const translate = useTranslate();
    const navigate = useNavigate();

    // eslint-disable-next-line @typescript-eslint/require-await
    async function handleSavedOrCancelled() {
        navigate('/settings/equipmenttypes');
    }

    return (
        <>
            <Topbar>
                <TopbarLeft>
                    {(props.params.id && <TopbarCrumbActive title={translate('common.editItem', translate('equipment.types'))} icon="fa-cogs" />) || (
                        <TopbarCrumbActive title={translate('common.addItem', translate('equipment.types'))} icon="fa-cogs" />
                    )}
                </TopbarLeft>
            </Topbar>
            <Content>
                <Tray>
                    <Panel small>
                        <PanelBody noPadding>
                            <ValidatingForm
                                schema={equipmentTypeSchema}
                                createUrl={'/api/equipmentTypes/'}
                                updateUrl={`/api/equipmentTypes/${props.params.id}`}
                                itemUrl={`/api/equipmentTypes/${props.params.id}`}
                                id={props.params.id}
                                onSubmitted={handleSavedOrCancelled}
                            >
                                <EditPanel>
                                    <EditPanelRow>
                                        <EditPanelCell rowCount={12}>
                                            <ValidatingFormInputText name="name" topLabel={translate('common.name')} />
                                        </EditPanelCell>
                                    </EditPanelRow>
                                    <EditPanelRow>
                                        <EditPanelCell rowCount={12}>
                                            <ValidatingEditPanelSwitch
                                                name="isPayload"
                                                placeholder={translate('equipment.isPayload')}
                                                onText="On"
                                                offText="Off"
                                            />
                                        </EditPanelCell>
                                    </EditPanelRow>
                                    <EditPanelRow>
                                        <EditPanelCell rowCount={12}>
                                            <ValidatingEditPanelSwitch
                                                name="hasLog"
                                                placeholder={translate('equipment.hasLog')}
                                                onText="On"
                                                offText="Off"
                                            />
                                        </EditPanelCell>
                                    </EditPanelRow>
                                </EditPanel>
                                <EditPanelButtons footer>
                                    <PanelButton text={translate('common.cancel')} onClick={handleSavedOrCancelled} />
                                    <ValidatingEditPanelSaveButton />
                                </EditPanelButtons>
                            </ValidatingForm>
                        </PanelBody>
                    </Panel>
                </Tray>
            </Content>
        </>
    );
}
